export default "__VITE_ASSET__BwnD3XE4__"